import { MetaReducer, ActionReducer, Action } from '@ngrx/store';
// import { UserStoreActions } from './user-store';

export function reset(reducer: ActionReducer<any>): ActionReducer<any> {
  return function newReducer(state, action) {
    // if (action.type === UserStoreActions.ActionTypes.LOGOUT_CONFIRMED) {
    //   state = undefined;
    // }

    const nextState = reducer(state, action);

    return nextState;
  };
}

/**
 * based on http://blog.brecht.io/Cancellable-optimistic-updates-in-Angular2-and-Redux/
 * @param rootReducer ActionReducer
 * @param bufferSize History limit
 */
export function handleUndo(
  rootReducer: ActionReducer<any>,
  bufferSize = 100
): ActionReducer<any> {
  let executedActions: Array<Action> = [];
  let initialState;
  return (state: any, action: Action) => {
    if (action.type === 'UNDO_ACTION') {
      // if the action is UNDO_ACTION,
      // then call all the actions again on the rootReducer,
      // except the one we want to rollback
      let newState: any = initialState;
      executedActions = executedActions.filter(
        (eAct) => eAct !== action['payload']
      );
      // update the state for every action untill we get the
      // exact same state as before, but without the action we want to rollback
      executedActions.forEach(
        (executedAction) => (newState = rootReducer(newState, executedAction))
      );
      return newState;
    }
    // push every action that isn't an UNDO_ACTION to the executedActions property
    executedActions.push(action);
    const updatedState = rootReducer(state, action);
    if (executedActions.length === bufferSize + 1) {
      const firstAction = executedActions[0];
      // calculate the state x (buffersize) actions ago
      initialState = rootReducer(initialState, firstAction);
      // keep the correct actions
      executedActions = executedActions.slice(1, bufferSize + 1);
    }
    return updatedState;
  };
}

export const metaReducers: MetaReducer<any>[] = [handleUndo, reset];
